<section class="agenx-create-edit__inputs--three">
  <div class="span-grid agenx-mb--2">
    <agenx-alert-radio [alertText]="'Al crear el cliente, será redireccionado para la creación del aforo.'"
      alertType="info" [loading]="false"></agenx-alert-radio>
  </div>

  <agenx-select [idInput]="'identification_type'" [control]="form.identification_type" [options]="typeIdentOpts"
    [label]="'Tipo identificación'" (onChange)="onTypeIdentChange()"></agenx-select>

  <agenx-input [control]="form.identification" [type]="'text'" [placeholder]="''"
     [idInput]="'identification'" [label]="'Identificación'"></agenx-input>

  <agenx-input [control]="form.code" [type]="'text'" [placeholder]="''"
    [idInput]="'code'" [label]="'Código'"></agenx-input>

  <agenx-input [control]="form.name" [type]="'text'" [placeholder]="''"
     [idInput]="'name'" [label]="'Nombre'"></agenx-input>

  <agenx-input [control]="form.phone" [type]="'text'" [placeholder]="''"
     [idInput]="'phone'" [label]="'Teléfono'"></agenx-input>

  <agenx-input [control]="form.email" [type]="'text'" [placeholder]="''"
     [idInput]="'email'" [label]="'Correo electrónico'"></agenx-input>

  <agenx-input [control]="form.neighborhood" [type]="'text'" [placeholder]="''"
     [idInput]="'neighborhood'" [label]="'Barrio'"></agenx-input>

  <agenx-input [control]="form.address" [type]="'text'" [placeholder]="''"
     [idInput]="'address'" [label]="'Dirección'"></agenx-input>

  <div style="justify-self: end;" class="span-grid">
    <agenx-button class="agenx-create-edit__button" [buttonText]="'Guardar'" [loadingButton]="loading"
      (click)="save()"></agenx-button>
  </div>

</section>
